import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { PageLoader } from "components/ezpay/common/page-loader";
import _ from "lodash";
import React from "react";
import { IPaymentRecord } from "types/Api/Payment/paymentRecord";
import { IBiller } from "types/biller";
import { CancelPaymentModal } from "./CancelPaymentModal";
import { PaymentAccordions } from "./PaymentAccordions";

interface RecentPaymentsContentProps {
  loadingStatus: boolean;
  upcomingPayment: IPaymentRecord | undefined;
  recentPayments: IPaymentRecord[];
  createPaymentIntentContent: (
    payment: IPaymentRecord,
    isExpanded: boolean,
  ) => React.ReactNode;
  biller: IBiller;
  confirmCancelModalOpen: boolean;
  isMobile: boolean;
  cancelState: string;
  cancelErrorMessage?: string;
  onCancelModalClose: () => void;
  onConfirmCancel: () => void;
  onReload: () => void;
}

export const RecentPaymentsContent = ({
  loadingStatus,
  upcomingPayment,
  recentPayments,
  createPaymentIntentContent,
  biller,
  confirmCancelModalOpen,
  isMobile,
  cancelState,
  cancelErrorMessage,
  onCancelModalClose,
  onConfirmCancel,
  onReload,
}: RecentPaymentsContentProps) => (
  <>
    <PageLoader />

    {!loadingStatus && (
      <PaymentAccordions
        upcomingPayment={
          _.isEmpty(upcomingPayment) ? undefined : upcomingPayment
        }
        recentPayments={recentPayments}
        createPaymentIntentContent={createPaymentIntentContent}
      />
    )}

    <ContactAndTocFooter biller={biller} />

    {!_.isEmpty(upcomingPayment) && (
      <CancelPaymentModal
        isOpen={confirmCancelModalOpen}
        isMobile={isMobile}
        cancelState={cancelState}
        cancelErrorMessage={cancelErrorMessage}
        upcomingPayment={upcomingPayment}
        onClose={onCancelModalClose}
        onConfirmCancel={onConfirmCancel}
        onReload={onReload}
      />
    )}
  </>
);
